import { Select } from "@mimber/ui-web"
import { FormItem } from "react-hook-form-antd"
import { useFormContext, FieldValues, FieldPath } from "react-hook-form"
import type { SelectFieldProps } from "./SelectField.types"

/**
 * SelectField component that integrates React Hook Form with Ant Design Select
 * Uses react-hook-form-antd's FormItem for seamless integration
 */
export function SelectField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  name,
  control,
  label,
  required,
  help,
  options,
  placeholder,
  disabled,
  size,
  variant,
  allowClear,
  showSearch,
  filterOption,
  mode,
  maxTagCount,
  loading,
}: SelectFieldProps<TFieldValues, TName>) {
  const { control: contextControl } = useFormContext<TFieldValues>()
  const formControl = control || contextControl

  return (
    <FormItem
      control={formControl}
      name={name}
      label={label}
      required={required}
      help={help}
    >
      <Select
        options={options}
        placeholder={placeholder}
        disabled={disabled}
        size={size}
        variant={variant}
        allowClear={allowClear}
        showSearch={showSearch}
        filterOption={filterOption}
        mode={mode}
        maxTagCount={maxTagCount}
        loading={loading}
      />
    </FormItem>
  )
}
